import { APP_CONFIG } from '@/constants/app';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';
import type {
  CreateSenderDto,
  Sender,
  TestSmtpDto,
  TestSmtpResponse,
  UpdateSenderDto,
} from '@/types/sender.types';

// Create axios instance for senders service
const sendersApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl + '/senders',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(sendersApi);

export const sendersService = {
  findAll: async (): Promise<Sender[]> => {
    const response = await sendersApi.get<Sender[]>('');
    return response.data;
  },

  findOne: async (uuid: string): Promise<Sender> => {
    const response = await sendersApi.get<Sender>(`/${uuid}`);
    return response.data;
  },

  findDefault: async (): Promise<Sender | null> => {
    const response = await sendersApi.get<Sender | null>('/default/current');
    return response.data;
  },

  create: async (data: CreateSenderDto): Promise<Sender> => {
    const response = await sendersApi.post<Sender>('', data);
    return response.data;
  },

  update: async (uuid: string, data: UpdateSenderDto): Promise<Sender> => {
    const response = await sendersApi.put<Sender>(`/${uuid}`, data);
    return response.data;
  },

  delete: async (uuid: string): Promise<void> => {
    await sendersApi.delete(`/${uuid}`);
  },

  setDefault: async (uuid: string): Promise<Sender> => {
    const response = await sendersApi.post<Sender>(`/${uuid}/default`);
    return response.data;
  },

  testSmtpConnection: async (data: TestSmtpDto): Promise<TestSmtpResponse> => {
    const response = await sendersApi.post<{ data: TestSmtpResponse }>(
      '/test-smtp',
      data
    );
    return response.data.data;
  },
};
